var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.602,
    height: 10.598,
    viewBox: "0 0 10.602 10.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "window-close",
    d: "M162.473,154.219l-3.13,3.13,3.13,3.13a.609.609,0,0,1,0,.856l-1.137,1.137a.609.609,0,0,1-.856,0l-3.13-3.13-3.13,3.13a.609.609,0,0,1-.856,0l-1.137-1.137a.609.609,0,0,1,0-.856l3.13-3.13-3.13-3.13a.609.609,0,0,1,0-.856l1.137-1.137a.609.609,0,0,1,.856,0l3.13,3.13,3.13-3.13a.609.609,0,0,1,.856,0l1.137,1.137A.6.6,0,0,1,162.473,154.219Z",
    transform: "translate(-152.05 -152.05)",
    fill: "#973937"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/closeRed.5b30de10acaa2be706f16c91d1bfe151.svg";
export { ForwardRef as ReactComponent };